import { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/material';

export default function HomepageTopAd({ adSpaceList }: { adSpaceList: any[] }) {
  const homepageAds = adSpaceList.filter(ad => ad.adPositionCode === 'homepage-top');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (homepageAds.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex(prev => (prev + 1) % homepageAds.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [homepageAds]);

  return (
    <>
      {homepageAds.length > 0 && (
        <Box
          sx={{
            // 💥 CRITICAL FIX: Use responsive width to prevent shrinking below a minimum.
            // On extra-small screens (xs), the ad will be at least 300px wide.
            // On larger screens (sm+), it will take 100% of the parent column, 
            // but will never be smaller than 300px.
            width: { xs: 300, sm: '100%' },
            height: 280,              // Locked height
            overflow: 'hidden',
            borderRadius: 2,
            position: 'relative',
            // Center the ad if its fixed width (300px) is less than the screen width
            mx: 'auto',
          }}
        >
          <a
            href={homepageAds[currentIndex].adSpaceThumbnailUrl || '#'}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'block',
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: 0,
              left: 0,
            }}
          >
            <img
              src={homepageAds[currentIndex].adSpaceImageUrl}
              alt={homepageAds[currentIndex].name || 'Advertisement'}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block',
              }}
            />
          </a>
        </Box>
      )}
    </>
  );
}